<template>

    <component :is="vvfield"
        v-model="col"
        :label="label"
        :placeholder="moneyPlaceholder"
        :rules="reg"
        :name="model"
        :min="min"
        :max="max"
    >
    </component>
</template>

<script>
import { Field } from 'vant';
import ValidHoc from '../../../../components/valid';

import { rangeCheck } from '../util';

const ValidVanField = ValidHoc(Field);

export default {
  name: 'RangeInput',
  components: {
    ValidVanField,
  },
  props: [
    'label',
    'placeholder',
    'min',
    'max',
    'model',
    'value',
  ],
  data() {
    const msg = `${this.min}-${this.max}(万元)正整数`;
    const placeHolderText = `${this.min}-${this.max}(万元)`;
    return {
      moneyPlaceholder: placeHolderText,
      reg: [{ vfunc: rangeCheck, message: msg }],
      modelKey: this.model,
      vvfield: ValidVanField,
    };
  },
  computed: {
    col: {
      get() {
        return this.$store.state.commonForms[this.model];
      },
      set(value) {
        this.$store.commit('commonForms/updateForm', {
          [this.model]: value,
        });
      },
    },
  },

};
</script>
